<template>
  <v-layout ma-4>
    <v-flex xs12 sm6 offset-sm3>
      <v-card v-ripple>
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">
              <!-- {{new Date(appointment.startTimeStamp).toLocaleString(undefined, {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
              hourCycle : "h24",
              hour: '2-digit',
              minute: '2-digit',
              })
              }}-->
              {{this.$moment(appointment.startTimeStamp).format('MMM DD, YYYY, HH:mm')}}
            </h3>
            <div>{{appointment.description}}</div>
          </div>
        </v-card-title>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: ["appointment"],
  data() {
    return {};
  }
};
</script>
